export const IconPaymentError: React.FC = () => (
  <svg
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60Z"
      fill="#F3F5F8"
    />
    <g clipPath="url(#clip0_22300_4120)">
      <path
        d="M27.6074 42.0039H92.3934"
        stroke="#D6453B"
        strokeWidth="5.18288"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.2539 56.4006H42.0039"
        stroke="#D6453B"
        strokeWidth="5.18288"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.2028 77.996H38.4051C32.4412 77.996 27.6074 73.1623 27.6074 67.1984V38.4046C27.6074 32.4407 32.4412 27.6069 38.4051 27.6069H81.5958C87.5597 27.6069 92.3934 32.4407 92.3934 38.4046V52.8015"
        stroke="#D6453B"
        strokeWidth="5.18288"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M95.9928 77.845C95.9928 87.8905 87.8909 95.9923 77.8455 95.9923C67.8001 95.9923 59.6982 87.8905 59.6982 77.845C59.6982 67.7996 67.8001 59.6978 77.8455 59.6978C87.8909 59.6978 95.9928 67.7996 95.9928 77.845Z"
        stroke="#D6453B"
        strokeWidth="5.18288"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.0156 90.6728L90.6709 65.0176"
        stroke="#D6453B"
        strokeWidth="5.18288"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_22300_4120">
        <rect
          width="86.3813"
          height="86.3813"
          fill="white"
          transform="translate(16.8096 16.8093)"
        />
      </clipPath>
    </defs>
  </svg>
);
